<div
  class="card m-2 {{ field.props?.['hideField'] ? 'd-none' : '' }} pointer-cursor">
  <div
    class="card-body d-flex justify-content-between"
    *ngIf="props"
    (click)="collapsed = !collapsed">
    <span>
      {{ props.label }}
      <span
        class="badge bg-primary ms-1"
        *ngIf="field?.props?.['badgeText'] !== undefined">
        {{ field.props?.['badgeText'] }}
      </span>
    </span>
    <span>
      <i
        *ngIf="field?.props?.['collapsible']"
        class="fa fa-solid ms-3 text-primary {{
          collapsed ? 'fa-angle-down' : 'fa-angle-up'
        }}"></i>
    </span>
  </div>
  <div class="card-body" *ngIf="!collapsed">
    <ng-container #fieldComponent></ng-container>
  </div>
</div>
